// src/services/auth.service.js
import api from './api';
import { jwtDecode } from 'jwt-decode';

class AuthService {
  // src/services/auth.service.js
  login(email, password) {
    // Opción 1: Usando URLSearchParams (recomendada)
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);

    return api.post('/auth/token', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(response => {
      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        
        // Decodificar el token para obtener la información del usuario
        const decodedToken = jwtDecode(response.data.access_token);
        const user = {
          email: decodedToken.sub,
          role: decodedToken.role
        };
        localStorage.setItem('user', JSON.stringify(user));
      }
      return response.data;
    });
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  register(nombre, email, password, municipioId = null) {
    // Convertir a entero si es string, o mantener null si no hay valor
    const municipio_id = municipioId ? parseInt(municipioId) : null;
    
    return api.post('/auth/register', {
      nombre,
      email,
      password,
      municipio_id: municipio_id
    });
  }

  confirmEmail(token) {
    return api.get(`/auth/confirm/${token}`);
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  isAdmin() {
    const user = this.getCurrentUser();
    return user && user.role === 'administrador';
  }
}

export default new AuthService();